export default "__VITE_ASSET__b795eb87__"